<template>
  <div class="hint" :class="type">
    <SvgIcon
      v-if="c_icon"
      :name="c_icon"
      :color="`var(--${c_color})`"
      class="hint__icon"
      height="20"
      width="20"
    />
    <UiText
      :text="text"
      font="body-text-small"
      :color="c_color"
      class="hint__text"
    />
  </div>
</template>

<script>
export const HINT_TYPES = {
  warning: { icon: 'hint/alert-triangle', color: 'form-hint-icon-color-warning' },
  error: { icon: 'hint/close-circle', color: 'form-hint-icon-color-error' },
  success: { icon: 'hint/check-circle', color: 'form-hint-icon-color-succes' },
  info: { icon: 'hint/alert-circle', color: 'form-hint-icon-color-info' },
  action: { icon: 'hint/plus', color: 'form-hint-icon-color-link' },
  help: { icon: '', color: 'form-hint-text-color-info' },
}
export default {
  name: 'UiHint',
  props: {
    type: { type: String, validator: (v) => Object.keys(HINT_TYPES).includes(v) },
    text: { type: String, required: true },
    color: { type: String },
    icon: { type: String },
    noIcon: { type: Boolean, default: false },
  },
  computed: {
    c_icon() {
      if (this.noIcon) return ''
      return this.icon ?? HINT_TYPES[this.type].icon
    },
    c_color() {
      return this.color ?? HINT_TYPES[this.type].color
    },
  },
}
</script>

<style lang="scss" scoped>
.hint {
  display: flex;
  gap: 4px;
  align-items: center;
  &__icon {
    flex-shrink: 0;
  }
}
</style>
